export default function shouldEnableInvoices(orgId) {
	return orgId === "HfvG4FQfXWpWv6dzqM5E";
}
